import  gql  from 'graphql-tag'

export const accountTypes = gql`query accountTypes($isActive: Boolean){ 
    accountTypes(isActive:$isActive){
            edges{
                node{
                    id,
                    code,
                    name,
                    isActive
                }
            }
        }
    }`;
